// Backend version - update this manually when the backend service is upgraded.
// Frontend version is now auto-managed: see src/buildInfo.generated.ts (regenerated
// on every npm start / npm run build) and scripts/bump-and-tag.js (runs as
// predeploy:* to bump package.json patch + commit + tag).
export const BACKEND_LAST_VERSION = '1.0.3';
export const BACKEND_VERSION = '1.0.3';
